<template>
  <div class="dash-header">
    <div class="dash-header-inner">
      <div class="welcome flexItem">
        <template>
          <router-link to="/" class="dash-head-logo">
            <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/logo.png" />
          </router-link>
        </template>
        <div class="ResMenu" v-if="oWidth <= 750" :class="{'on':isShow}" @click="menuClick">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <!-- <div class="searchDiv" v-if="!$config.settings.onlayReg">
          <el-input readonly size="mini" v-if="subjectType != 'ACTOR'" @click.native="goSearch"
            :placeholder="$t('homes.searchPlaceHolder')" prefix-icon="el-icon-search" v-model="searchInput"> </el-input>
        </div> -->
        <div class="searchDiv" v-if="!$config.settings.onlayReg">
          <div class="theme-color" :class="oWidth <= 750 ? '' :'flex'">
            <div class="mb8 font-size-14" style="margin-right: 90px;">
              <i class="el-icon-time" style="margin-right: 3px;"></i>{{ $t('开展时间英文') }}
            </div>
            <div class="mb8 font-size-14">
              <i class="el-icon-location-outline" style="margin-right: 3px;"></i>{{ $t('开展地点英文') }}
            </div>
          </div>
        </div>
      </div>

      <div class="welcome">
        <span v-if="isLogin" class="account font-size-16" @click="goDash">{{$t('finds.myWorker')}}</span>
        <span v-if="isLogin" class="line-mar">|</span>
        <template v-if="$store.state.config.hideElement">
          <template v-if="isLogin">
            <span class="font-size-14">{{ name || loginAccount || '--' }}</span>
            <a href="javascript:void(0)" @click="LogOut" class="font-size-16">{{ $t('logout') }}</a>
            <!-- <span class="line-mar">|</span> -->
          </template>
          <span v-else class="link Link font-size-16" @click="goLogin" :class="{'login_link_en': language == 'en'}">
            <span class='login-iconfont iconfont icon92act_zhucedenglu'></span>
            {{ $t('registerLogin') }}
          </span>
          <!-- <span class="head-roles" v-if="isLogin"><i>{{ $t('finds.currentUser') }}：</i>
            <font>{{ subjectType == 'VISITOR' ? $t('actor') : $t('exhibitors') }}</font>
          </span> -->
        </template>
        <div class='el-menu-iconfont language-change' v-if="false">
          <i class="iconfont iconicon_A" @click="setLang('en')" v-if="language === 'zh'"></i>
          <i class="iconfont iconyuyanqiehuancon" @click="setLang('zh')" v-if="language === 'en'"></i>
        </div>
      </div>
    </div>
    <div class="navBar" :style="{display: (isShow == false ? 'none' : 'block')}"
      :class="{'limit-nav': $config.settings.onlayReg}">
      <nav>
        <el-menu :default-active="activeIndex" class="el-menu-header" mode="horizontal" :router="true">
          <el-menu-item index="/" @click="navRouter('', '001035001')">
            {{ $t('homes.Home') }}
            <div v-if="activeIndex == '/'"
              style="width:40px;height: 3px;background: #fff;margin: auto;position: relative;top:-15px;border-radius: 2px;">
            </div>
          </el-menu-item>
          <el-menu-item
            @click="goUrl('https://izt.eastfair.cn/h5-web/#/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/imaster/b33d8960b7a245cb97146670283ac360/14451593__1734486503992.png')">
            About CAC
          </el-menu-item>
          <el-menu-item index="/find/actor" @click="navRouter('actor','001035002')"
            v-if="subjectType == 'VISITOR'||subjectType == ''">{{ $t('homes.Exhibitor') }}
            <div v-if="activeIndex == '/find/actor'"
              style="width:40px;height: 3px;background: #fff;margin: auto;position: relative;top:-15px;border-radius: 2px;">
            </div>
          </el-menu-item>
          <el-menu-item index="/find/product" @click="navRouter('product','001035003')"
            v-if="subjectType == 'VISITOR'||subjectType == ''">{{ $t('homes.Products') }}
            <div v-if="activeIndex == '/find/product'"
              style="width:40px;height: 3px;background: #fff;margin: auto;position: relative;top:-15px;border-radius: 2px;">
            </div>
          </el-menu-item>
          <template v-if="$store.state.config.hideElement">
            <el-menu-item index="/find/person" @click="navRouter('person')" v-if="subjectType == 'ACTOR'">
              {{$t('homes.Visitor') }}
              <div v-if="activeIndex == '/find/product'"
                style="width:40px;height: 3px;background: #fff;margin: auto;position: relative;top:-15px;border-radius: 2px;">
              </div>
            </el-menu-item>
            <el-menu-item index="/news">
              {{ $t('News') }}
              <div v-if="activeIndex == '/news'"
                style="width:40px;height: 3px;background: #fff;margin: auto;position: relative;top:-15px;border-radius: 2px;">
              </div>
            </el-menu-item>

            <el-menu-item index="/boothMapList">
              {{ $t('boothGuide') }}
              <div v-if="activeIndex == '/boothMapList'"
                style="width:40px;height: 3px;background: #fff;margin: auto;position: relative;top:-15px;border-radius: 2px;">
              </div>
            </el-menu-item>



            <!-- <el-menu-item index="/find-opportunity" @click="navRouter('find-opportunity', '001035005')">
              {{$t('finds.businessCircle') }}
              <div v-if="activeIndex == '/find-opportunity'"
                style="width:40px;height: 3px;background: #fff;margin: auto;position: relative;top:-15px;border-radius: 2px;">
              </div>
            </el-menu-item>
            <el-menu-item v-if="subjectType == 'VISITOR'||subjectType == ''" index="/purchaseMeeting">
              {{$t('homes.purchaseMeeting') }}
              <div v-if="activeIndex == '/purchaseMeeting'"
                style="width:40px;height: 3px;background: #fff;margin: auto;position: relative;top:-15px;border-radius: 2px;">
              </div>
            </el-menu-item> -->
            <!--  index="/meetingList" -->
            <el-menu-item>
              {{ $t('meetingList') }}
              <div v-if="activeIndex == '/meetingList'"
                style="width:40px;height: 3px;background: #fff;margin: auto;position: relative;top:-15px;border-radius: 2px;">
              </div>
            </el-menu-item>

            <!--  index="/onsiteServiceFacilities" @click="navRouter('OnsiteServiceFacilities')" -->
            <el-menu-item>
              Onsite Service
              <div v-if="activeIndex == '/onsiteServiceFacilities'"
                style="width:40px;height: 3px;background: #fff;margin: auto;position: relative;top:-15px;border-radius: 2px;">
              </div>
            </el-menu-item>
            <!-- <el-menu-item index="/aboutus" @click="navRouter('aboutus')">
              {{ $t('homes.About') }}
              <div v-if="activeIndex == '/aboutus'"
                style="width:40px;height: 3px;background: #fff;margin: auto;position: relative;top:-15px;border-radius: 2px;">
              </div>
            </el-menu-item> -->

          </template>

        </el-menu>
      </nav>
    </div>

  </div>
</template>
<script>
import { watchLog } from '@/api/live'
import { mapState, mapGetters } from 'vuex'
import { getUserInfoFn } from '@/permission'

export default {
  name: 'DashHeader3',
  components: {
  },
  data() {
    return {
      isShow: false,
      oWidth: document.body.clientWidth,
      activeIndex: '/',
      searchInput: ''
    }
  },
  computed: {
    ...mapState({
        newMessageComing: state => state.timStore.newMessageComing,
    }),
    ...mapGetters(['language', 'name', 'isLogin', 'info', 'subjectType', 'loginAccount']),
    noAdmin() {
      return (
        !this.info || (this.info && !this.info.exhibitorEmployee) || (this.info && this.info.exhibitorEmployee && !this.info.exhibitorEmployee.admin)
      )
    }
  },
  watch: {
    $route: function() {
      this.menuActive()
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.menuActive()
    });
    if(this.oWidth > 750){
      this.isShow = true
    }else{
      this.isShow = false
    }

    if (this.isLogin) {
      getUserInfoFn()

      console.log('indexHeader头部组件 getUserInfoByToken')
    }
  },
  methods: {
    goUrl(url) {
      if (url) {
        this.openNewPage(url, true)
      }
    },
    // 菜单跳转
    navRouter(name, num, url) {
        if (num) {
            this.statistics(num)
        }
        window.PC.$RangersEventNav(name)
        if (url) {
            this.openNewPage(url, true)
        }
        this.menuClick()
    },
    // 埋点方法
    statistics(action) {
      this.commonStatistics(action)
    },
    // 点击菜单选中
    menuActive: function() {
      let path = this.$route.path
      if (this.$route.meta && this.$route.meta.pPath) {
        path = this.$route.meta.pPath
      }
      this.activeIndex = path  
    },
    // 切换语音
    setLang(language) {
      this.$i18n.locale = language
      this.$store.commit('SET_LANGUAGE', language)
      location.reload()
    },
    // 退出登录
    LogOut() {
      if (this.$route.name == 'liveDetail' && this.$route.params.id != '') {
        let watchType = sessionStorage.getItem('watchType') || 1
        try {
          watchLog({ liveId: this.$route.params.id, state: 2, watchType: Number(watchType) }).then((res)=>{
            console.log(res)
            this.$store.dispatch('LogOut').then(() => {
              this.$router.push('/')
            })
          })
        } catch (error) {
          console.log(error)
        }
        
      }else {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.push('/')
        })
      }
    },
    // 消息客服
    customerService(item) {
      item.position = this.$t('Online Service')
      this.$store.commit('setReceiver', item)
      this.$store.commit('toogleChatDialog')
    },
    // 搜索
    goSearch() {
      this.navRouter("search")
      this.$router.push('/search-list')
    },
    // 工作台默认进入 浏览记录
    goDash() {
      this.navRouter("workbench")
      if (this.subjectType === 'VISITOR' && this.$config.settings.onlayReg2) {
        this.$router.push('/footprint/exhibitor')
        return
      }
      this.$router.push('/footprint/exhibitor')
      // this.$router.push('/opportunity-manage/publish')
    },
    // 登录
    goLogin() {
      this.navRouter("signUp")
      // this.$store.commit('SET_SUBJECTTYPE', '')
      // this.loginSource()
      // TODO 登录观众
      this.$store.commit('SET_SUBJECTTYPE', 'VISITOR')
      this.loginSource('/login/person')
    },
    // 导航是否显示
    menuClick(){
      if(this.oWidth <= 750){
        this.isShow = !this.isShow
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
link-color = $color-main
link-hover = $color-main-hover

.limit-nav {
  position: relative;

  &:before{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index 100
  }
}

.account {
  color: $color-main;
  cursor pointer;

  &:hover {
    opacity: .8;
    text-decoration underline;
  }
}
.line-mar {
  color: $color-gray-d9 
}
.external_link
  display block
.searchDiv
    display: inline-block;
    // margin-left: 24px;
    // width 400px;
    transition: all .3s;
    .el-select .el-input {
        width: 100px;
    }
    .input-with-select .el-input-group__prepend {
        background-color: $color-white;
    }
a
  color link-color
  &:hover
    color link-hover
.homeHeader
  .exhibitors{
    background  $color-exhibitors
  }
  .visitor{
    background  $color-index-homeHeader-vistor
    border 1px solid $color-index-homeHeader-vistor
  }
  .navBar
    width 100%
    background $color-index
    text-align: center;
    height 68px
  .iconfont
    display: block
    position relative
    top 0
    left 0
    padding-top 2px
    width 25px
    font-size 25px
    cursor pointer
    margin: 0
  nav
    display: inline-block;
    vertical-align: middle;
    .el-menu-item
      min-width 184px
      text-align center
      height 68px;
      line-height 68px
      color: $color-white !important
      background-color : $color-main !important
      transition: all .3s;
      font-size 18px
      &.is-active
        background-color $color-index-navBar-hover !important
        font-weight:bold;
      &.el-menu-iconfont:hover
        background-color transparent!important
    ul
      box-sizing border-box
    a
      color $color-white
    a:hover
      color $color-white
    > a
      display inline-block
      padding 0 12.5px
      text-align center
      position relative
      &:before
        content ''
        position absolute
        right 0
        top 5px
        width 1px
        height 12px
        background $color-black-15
      &:last-child:before
        display none

.dash-header-inner
  max-width $container-width
  margin 0 auto
  padding 6px 15px
  height 80px
  display flex
  align-items center
  justify-content space-between
  color $color-black-65
  font-weight 400
  line-height 20px
  .welcome
    font-size 12px

    .dash-head-logo
      display inline-block
      height 40px
      width 245px
      padding:6px 0
      img
        height 100%
    .head-roles
      margin-right: 0;
      i 
        font-style initial
      font
        color $color-index
    *
      margin-right 12px
.el-menu-header{
    height 50px
}
.dash-header .navBar .el-menu.el-menu--horizontal .el-menu-item{
    min-width 184px
    text-align center
    height 68px;
    line-height 68px
    font-size 18px
    &.el-menu-iconfont{
        min-width: 50px;
    }
}
.Menu{
  display none
}

@media (max-width: 1240px) {
    .searchDiv {
        // margin-left: 120px;
        // width: 250px;
    }

    .dash-header .navBar .el-menu.el-menu--horizontal .el-menu-item {
        min-width: 128px;
    }
}
</style>
